import useCerosScript from "@hooks/useCerosScript";
import { ArticleNonParagraphProps } from "@pages/Article/components/ArticleParagraphElements/utils/types";
import { cn } from "@util/helpers";
import parse from "html-react-parser";

/**
 * Renders a dynamic iframe element in an article.
 * This component processes the body string to extract and add the necessary scripts to the page.
 */
const DynamicIframe = ({
  bodyString,
  className,
  paragraphWidth,
}: ArticleNonParagraphProps) => {
  useCerosScript();

  return (
    <div
      data-testid="article-dynamic-iframe-component"
      className={cn("mb-6", className, paragraphWidth)}
    >
      {parse(bodyString)}
    </div>
  );
};

export default DynamicIframe;
